var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyDietPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4185_9061",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H32C40.8366 0 48 7.16344 48 16V32C48 40.8366 40.8366 48 32 48H16C7.16344 48 0 40.8366 0 32V16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H32C40.8366 0 48 7.16344 48 16V32C48 40.8366 40.8366 48 32 48H16C7.16344 48 0 40.8366 0 32V16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48H0ZM48 32C48 41.3888 40.3888 49 31 49H17C7.61116 49 0 41.3888 0 32C0 40.2843 7.16344 47 16 47H32C40.8366 47 48 40.2843 48 32ZM0 48V0V48ZM48 0V48V0Z",
    fill: "#CDECC6",
    mask: "url(#path-1-inside-1_4185_9061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0781 18H20.6719C19.1962 18 18 19.1962 18 20.6719V31.0781C18 32.5538 19.1962 33.75 20.6719 33.75H31.0781C32.5538 33.75 33.75 32.5538 33.75 31.0781V20.6719C33.75 19.1962 32.5538 18 31.0781 18Z",
    stroke: "#548054",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9766 18L30 16.875C29.998 16.1794 29.7208 15.5129 29.229 15.021C28.7371 14.5292 28.0706 14.252 27.375 14.25H17.25C16.4551 14.2523 15.6934 14.5692 15.1313 15.1313C14.5692 15.6934 14.2523 16.4551 14.25 17.25V27.375C14.252 28.0706 14.5292 28.7371 15.021 29.229C15.5129 29.7208 16.1794 29.998 16.875 30H18M25.875 22.125V29.625M29.625 25.875H22.125",
    stroke: "#548054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDietPlan);
export default __webpack_public_path__ + "static/media/copy-diet-plan.92a4d24162531ca97732c4b077deae4a.svg";
export { ForwardRef as ReactComponent };